const AddNoteIcon = ({ width = 16, height = 16, color = '#6E6E73' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.22192 2.17638L2.76562 7.63281V10.5495H5.68229L11.1386 5.09303C11.5942 4.63741 11.5942 3.89873 11.1386 3.44312L9.87184 2.17637C9.41623 1.72075 8.67753 1.72076 8.22192 2.17638Z"
        stroke={color}
        strokeWidth="1.336"
      />
      <path d="M2 13.8633H14" stroke={color} strokeWidth="1.336" />
    </svg>
  )
}

export default AddNoteIcon
